export default {
    roomDoc: function(state, getters, rootState, rootGetters){
        return rootState.room.roomDoc;
    },
    getRoomDoc: (state, getters, rootState, rootGetters) => (roomGroupId) => {
        let roomGroup = rootGetters["roomGroup/getRoomGroup"](roomGroupId);
        if(!roomGroup){
            console.warn('roomGroup is null :', roomGroupId);
            return null;
        }
        return roomGroup.roomDoc;
    },
    sharingRoomDoc: function(state, getters, rootState, rootGetters){
        let roomGroupList = rootGetters["roomGroup/roomGroupList"];
        let roomGroup = roomGroupList.find(rg => (rg.roomDoc && rg.roomDoc.isSharing))
        return roomGroup
    },
    sharingRoomGroupId: function(state, getters) {
        return state.roomGroupId
    },
    isWhiteBoardFile: (state, getters, rootState) => (docFile) => {
       if(!docFile){
            return false;
        }
        return docFile.docType === 'wb';
    },
    getRoomDocFiles: (state, getters, rootState) => ({roomGroupId}) => {
        let roomDoc = getters.getRoomDoc(roomGroupId);
        if(!roomDoc){
            return null;
        }
        return roomDoc.roomDocFiles;
    },
    getCurrentRoomDocFile: function(state, getters, rootState, rootGetters){
        let roomDoc = getters.roomDoc;
        if(!roomDoc){
            return null;
        }
        return roomDoc.roomDocFiles.find(rd => rd.docId === roomDoc.docId);
    },
    getRoomDocFile: (state, getters, rootState) => ({docId, roomGroupId}) => {
        let roomDoc = getters.getRoomDoc(roomGroupId);
        if(!roomDoc){
            return null;
        }
        let roomDocFile = roomDoc.roomDocFiles.find(file => file.docId == docId);
        return roomDocFile;
    },
    getRoomDocFilePage: (state, getters, rootState) => ({docId, docPageId, roomGroupId}) => {
        let pages = getters.getRoomDocFilePages({docId, roomGroupId});
        if(!pages){
            return null;
        }
        let page = pages.find(page => page.docPageId == docPageId);
        return page;
    },
    getRoomDocFilePages: (state, getters, rootState) => ({docId, roomGroupId}) => {
        let roomDocFile = getters.getRoomDocFile({docId, roomGroupId});
        if(!roomDocFile){
            return null;
        }
        return roomDocFile.pages;
    },
    uploadRoomDocFilesGroup: function(state, getters, rootState) {
        return state.uploadRoomDocFiles.filter(rd => rd.roomGroupId !='default');
    },
    firstWhiteBoardRoomDocFile: function(state, getters, rootState) {
        let roomDoc = getters.getRoomDoc('default');
        let wb = roomDoc.roomDocFiles.find(rdf => rdf.docType === 'wb');
        return wb;
    },
    allowedFileExts: (state) => {
        return state.allowedFileExts
    },
    isOpenDocFileList: (state) => {
        return state.isOpenDocFileList;
    },
    isDocFileConverting: (state, getters, rootState) => (roomDocFile) => {
        if(!roomDocFile) return false;
        let docState = roomDocFile.docState || roomDocFile.docFile?.docState;
        return docState === 1;
    },
    isDocFileConverted: (state, getters, rootState) => (roomDocFile) => {
        if(!roomDocFile) return false;
        if(getters.isWhiteBoardFile(roomDocFile)) return true;
        let docState = roomDocFile.docState || roomDocFile.docFile?.docState;
        return docState === 9;
    },
    isDocFileConvertError: (state, getters, rootState) => (roomDocFile) => {
        if(!roomDocFile) return false;
        let docState = roomDocFile.docState || roomDocFile.docFile?.docState;
        return docState === 2;
    },
    hasDocFilePage: (state, getters, rootState) => (roomDocFile) => {
        return roomDocFile.docFile && (roomDocFile.docFile.docPageCnt > 0 || roomDocFile.docFile.docConvPageCnt > 0);
    },
}
